import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";
import { useLang } from "../contexts/LanguageContext";
import { Button } from "./ui/button";

const STORAGE_KEY = "sereno_cookie_consent_v1";

const T = {
  fr: {
    title: "Un mot sur les cookies",
    body:
      "Sereno utilise uniquement un cookie technique pour garder votre session ouverte. Aucun cookie de pub, aucun tracking tiers.",
    accept: "J'ai compris",
    more: "En savoir plus",
  },
  en: {
    title: "A word on cookies",
    body:
      "Sereno uses only a technical cookie to keep your session open. No advertising cookies, no third-party tracking.",
    accept: "Got it",
    more: "Learn more",
  },
};

export default function CookieBanner() {
  const { lang } = useLang();
  const tr = T[lang] || T.fr;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    } catch {
      /* ignore */
    }
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <div
      data-testid="cookie-banner"
      role="dialog"
      aria-label={tr.title}
      className="fixed bottom-4 left-4 right-4 z-50 mx-auto max-w-xl rounded-2xl border-2 border-[#101A42] bg-white p-4 shadow-[0_16px_40px_rgba(30,63,51,0.25)] sm:p-5"
    >
      <div className="flex items-start gap-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#E59D32]/25 text-[#8A6300]">
          <Cookie className="h-5 w-5" />
        </div>
        <div className="flex-1">
          <p className="font-serif text-lg font-semibold text-[#101A42]">
            {tr.title}
          </p>
          <p className="mt-1 text-sm leading-relaxed text-[#4A4A4A]">
            {tr.body}
          </p>
          <div className="mt-3 flex flex-wrap items-center gap-3">
            <Button
              onClick={accept}
              data-testid="cookie-accept-btn"
              className="min-h-[44px] rounded-full bg-[#101A42] px-5 text-base font-semibold text-white hover:bg-[#1A2650]"
            >
              {tr.accept}
            </Button>
            <Link
              to="/confidentialite"
              data-testid="cookie-more-link"
              className="text-sm font-semibold text-[#101A42] underline underline-offset-4 hover:text-[#A762B1]"
            >
              {tr.more}
            </Link>
          </div>
        </div>
        <button
          type="button"
          onClick={accept}
          aria-label={tr.accept}
          data-testid="cookie-close-btn"
          className="rounded-full p-1 text-[#4A4A4A] hover:bg-[#FFF7E9]"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
